import { INITIAL_DEALERS_REQUEST, FETCH_DEALERS_SUCCESS, INITIAL_DEALER_REQUEST, FINAL_DEALER_REQUEST } from "../../types/maintainers/dealers.type";

const initialState = {
	dealers: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_dealers(state = initialState, action) {
	switch (action.type) {
		case INITIAL_DEALERS_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case INITIAL_DEALER_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FINAL_DEALER_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case FETCH_DEALERS_SUCCESS:
			return {
				...state,
				dealers: action.payload.dealers,
				isFetching: false,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		default:
			return state;
	}
}

export default maintainers_dealers;
